/**
 * @desc 冻结库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.StockFreezeRecordRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/stockFreezeRecord/freezed`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
